import { z } from "zod"

// Version 1 ---------------------
export const SubheadingElementV1 = z.object({
  id: z.string(),
  name: z.literal("subheading"),
})

export type TSubheadingElementV1 = z.infer<typeof SubheadingElementV1>

// Latest ---------------------
export const SubheadingElement = SubheadingElementV1
export type TSubheadingElement = TSubheadingElementV1
